module.exports = __webpack_public_path__ + "static/media/print-slash.ee3d6962.svg";